import { Routes } from '@angular/router';
import { ActivityComponent, DashboardComponent, SummaryComponent } from '../upgrade/dashboard.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';

export const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: {
      state: 'dashboard.index'
    },
    canActivate: [setupGuard]
  },
  {
    path: 'summary/:user',
    component: SummaryComponent,
    data: {
      state: 'dashboard.summary',
      permission: 'users.view'
    },
    canActivate: [setupGuard, authGuard, forceOnlineGuard]
  },
  {
    path: 'activities',
    component: ActivityComponent,
    data: {
      state: 'dashboard.activities'
    },
    canActivate: [setupGuard]
  }
];
